/*@ngInject*/
const UINumberWithoutCommasFormatterDirective = function ($timeout, submissionConstant) {

    let linkFunction = function ($scope, $elm, $attrs, ngModelController) {

        let isEnabled,
            element = $($elm),
            timeoutList = [];

        function run() {

            function handleFocus() {
                let strLength;
                if (ngModelController.$modelValue) {
                    let viewValue = ngModelController.$viewValue;
                    viewValue = _.replace(viewValue, /\,/gi, '');

                    ngModelController.$viewValue = viewValue;
                    ngModelController.$render();
                } else {
                    ngModelController.$viewValue = '';
                    ngModelController.$render();
                }
                strLength = ngModelController.$viewValue.length;
                $elm[0].setSelectionRange(strLength, strLength);
            }

            function handleKeydown(event) {
                if (!isKeyAllowed(event)) {
                    return event.preventDefault();
                }
            }

            function isKeyAllowed(event) {
                let currentChar = event.keyCode || event.which;

                // allow TAB, ENTER
                if (_.includes([9, 13], currentChar)) {
                    return true;
                }
                // disallow COMMA
                else if (currentChar === 44) {
                    return false;
                }

                return _.isNumber(_.parseInt(String.fromCharCode(currentChar)));
            }

            $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, function () {
                if (element.is(':focus')) {
                    handleFocus();
                }
            });

            element.on('focus', handleFocus);
            element.on('keypress', handleKeydown);

            $scope.$on('$destroy', function () {
                element.off('focus', handleFocus);
                element.off('keypress', handleKeydown);
            });
        }

        timeoutList.push($timeout(function () {
            isEnabled = $elm.hasClass('ui-number-without-commas-formatter');

            if (isEnabled) {
                run();
            }
        }, 300));

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'A',
        require: 'ngModel',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiNumberWithoutCommasFormatter', UINumberWithoutCommasFormatterDirective);
